import { asLeadInfoScore } from 'Src/types/server-helpers';
import { getFromSessionStorage } from 'Client/session-storage-api/sessionStorageApi';
import { SET_DATA_SCORE, DATA_SCORE_SESSION_STORAGE_KEY } from './constants';
const initialState = {
  score:
    parseFloat(asLeadInfoScore(getFromSessionStorage(DATA_SCORE_SESSION_STORAGE_KEY)) ?? '') || 0,
};
type LeadInfoState = {
  score: number;
};

const leadInfosReducer = (
  state: LeadInfoState = initialState,
  action: Action<any>,
): LeadInfoState => {
  const { type, payload } = action;

  if (type === SET_DATA_SCORE) {
    return { ...state, score: payload.score };
  }

  return state;
};

export { leadInfosReducer };
